module.exports = __webpack_public_path__ + "images/location.4dedd617f3071fce5ef43f13844cf70f.png";